$(document).ready(function() {
  // Initialize the slick slider for .hp-spring__brand-items
  $('.hp-spring__brand-items').on('init', function(event, slick){
    $('.hp-spring__brand-items.slick-initialized').css({'opacity': '1', 'visibility': 'visible'});
  });

  $('.hp-spring__brand-items').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 7,
    centerMode: true,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 2000
  });

  // Initialize the slick slider for .hp-tab__contents
  // $('.hp-tab__contents').slick({
  //   arrows: false,
  //   dots: true,
  //   infinite: true,
  //   slidesToShow: 1,
  // });
  
  // Handle main menu link click
  // $('.main-menu-link').on('click', function(e) {
  //   e.preventDefault();
  // });

  // Handle tab button click
  $('.hp-tab__btn').on('click', function() {
    $('.hp-tab__btn').removeClass('active');
    $('.hp-tab__content').removeClass('active');
    $(this).addClass('active');

    var tabIndex = $(this).attr('data-index');
    $('.hp-tab__content[data-index="' + tabIndex + '"]').addClass('active');
  });

  $('.button--klaviyo').on('click', function() {
    $('.klaviyo').addClass('active');
    $('html, body').addClass('modal-opened');
  });

  $('.close').on('click', function() {
    $('.klaviyo').removeClass('active');
    $('html, body').removeClass('modal-opened');
  });


  // if ($('.product-option[data-gift="gift-message"]').length > 0) {
  //   $('.gift-popup').addClass('active');
  // }

  $('.gift-popup__close').on('click', function() {
    $('.gift-popup').removeClass('active');
  });

  $('html').click(function(e) {                    
    if($(e.target).hasClass('gift-popup')) {
      $('.gift-popup').removeClass('active');
    }
  }); 
  
});




/*
$(document).ready(function() {
  if ($(window).width() > 749) {
    $('.hp-spring__brand-items').on('init', function(event, slick){
      $('.hp-spring__brand-items.slick-initialized').css({'opacity': '1', 'visibility': 'visible'});
    });
  
    $('.hp-spring__brand-items').slick({
      arrows: false,
      dots: false,
      infinite: true,
      slidesToShow: 7,
      centerMode: true,
      variableWidth: true,
      autoplay: true,
      autoplaySpeed: 2000
    });
  }

  if ($(window).width() < 750) {
    $('.hp-tab__contents').slick({
      arrows: false,
      dots: true,
      infinite: true,
      slidesToShow: 1,
    });
    
    $('.main-menu-link').on('click', function(e) {
      e.preventDefault();
    })
  }
  

  $('.hp-tab__btn').on('click', function() {
    $('.hp-tab__btn').removeClass('active');
    $('.hp-tab__content').removeClass('active');
    $(this).addClass('active');

    var tabIndex = $(this).attr('data-index');
    $('.hp-tab__content[data-index="' + tabIndex + '"]').addClass('active');
  });
});
*/